var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02513 2.05052C0.658291 3.41735 0.658291 5.63343 2.02513 7.00026L8.00004 12.9752L13.9749 7.00026C15.3417 5.63343 15.3417 3.41735 13.9749 2.05052C12.608 0.683682 10.392 0.683682 9.02513 2.05052L8.00004 3.07568L6.97487 2.05052C5.60804 0.683682 3.39196 0.683682 2.02513 2.05052Z",
    stroke: "#525252",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBig);
export default __webpack_public_path__ + "static/media/heart-big.f3b8432139d77ec626bfb2922ff5a886.svg";
export { ForwardRef as ReactComponent };